import React from 'react';
import styled from 'styled-components';
import { AlertTriangle } from 'lucide-react';

const WarningContainer = styled.div`
  background: var(--warning);
  background: linear-gradient(135deg, var(--warning) 0%, #fbbf24 100%);
  border: 1px solid var(--warning);
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
`;

const WarningIcon = styled.div`
  color: #92400e;
  flex-shrink: 0;
  transition: color 0.3s ease;
`;

const WarningText = styled.div`
  color: #92400e;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  flex: 1;
  transition: color 0.3s ease;
`;

const SecurityWarning: React.FC = () => {
  return (
    <WarningContainer>
      <WarningIcon>
        <AlertTriangle size={20} />
      </WarningIcon>
      <WarningText>
        В целях безопасности все активные задачи автоматически останавливаются при перезагрузке страницы
      </WarningText>
    </WarningContainer>
  );
};

export default SecurityWarning;
